<template lang="html">
  <div class="contactUs">
    <img src="../assets/images/contact/contact-banner.jpg" alt="" class="bannerImg">
    <div class="textForm">
      <div class="formBox">
        <div class="titles">{{ $t('contact.contactUs') }}</div>
        <div class="bottom">
          <div class="left">
            <div class="item">
              <img src="../assets/images/contact/address.png" alt="">
              <div class="t1">{{ $t('contact.a1') }}</div>
              <div class="p">{{ $t('contact.a2') }}</div>
            </div>
            <div class="item">
              <img src="../assets/images/contact/phone.png" alt="">
              <div class="p">
                <span>{{ $t('contact.p2') }}</span>
                <span>{{ $t('contact.p4') }}</span>
                <span>{{ $t('contact.p6') }}</span>
                <span>{{ $t('contact.p5') }}</span>
                <span>{{ $t('contact.p7') }}</span>
                <span>{{ $t('contact.p1') }}</span>
                <span>{{ $t('contact.p3') }}</span>
              </div>
            </div>
            <div class="item">
              <span class="tips">{{ $t('contact.tips')  }}</span>
            </div>
          </div>
          <div class="right PC">
            <!-- <div class="textarea"></div> -->
            <textarea cols="30" rows="10" class="textarea" placeholder="Notes" v-model="notesText"></textarea>
            <div class="send" @click="clickSend">
              <img src="../assets/images/contact/send.png" alt="">
            </div>
          </div>
          <div class="right H5">
            <div class="mack" @click="toWapChat()"></div>
            <!-- <div class="textarea"></div> -->
            <textarea name="" id="" cols="30" rows="10" class="textarea" placeholder="Notes" disabled></textarea>
            <div class="send">
              <img src="../assets/images/contact/send.png" alt="">
            </div>
          </div>

        </div>
      </div>
    </div>
    <img :src="$t('contact.map')" alt="" class="bannerImg">
  </div>
</template>

<script>
// import bannerTop from '@/components/bannerTop'
export default {
  name: "contact",
  data() {
    return {
      notesText: ""
    };
  },
  components: {
    // bannerTop 这是一个用字符串拼接出来的函数showChatBOx，我现在希望把showChatBOx中的参数e添加到&title=MaesInfo后面的encode，应该怎么拼，我现在这种拼法浏览器会把e当成字母识别
  },
  methods: {
    async clickSend() {
      let encodeText = null;
      if (this.notesText) {
        encodeText = encodeURIComponent(this.notesText);
      }
      showChatBOx();
      if (encodeText) {
        await this.$nextTick();
        this.buildConnection(encodeText);
        this.notesText = "";
      }
    },
    // 建立连击
    buildConnection(encodeText) {
      const serviceChat = document.getElementById("serviceChat");
      if (serviceChat.attachEvent) {
        serviceChat.attachEvent("onload", () => {
          const iframeWin = serviceChat.contentWindow;
          iframeWin.postMessage(encodeText, `https://chat.melinked.com/index`);
        });
      } else {
        serviceChat.onload = () => {
          const iframeWin = serviceChat.contentWindow;
          iframeWin.postMessage(encodeText, `https://chat.melinked.com/index`);
        };
      }
    }
  }
};
</script>

<style lang="less">
.contactUs {
  .info {
    display: flex;
    flex-flow: column;
    align-items: center;
    padding: 2rem 2rem 5rem;

    .labelTitle {
      color: #254193;
      margin: 0;
      padding: 0;
    }

    .description {
      max-width: 50%;
      font-size: 1.25rem;
      color: #333;
    }
  }

  .address {
    display: flex;
    flex-flow: row;
    flex-wrap: wrap;
    // max-width: 80%;
    margin: 0 auto;
    align-items: flex-start;
    justify-content: space-around;
    text-align: left;

    .title {
      font-size: 2rem;
      font-weight: 700;
      padding: 0;
      margin: 0;
      color: #254193;

      img {
        margin-right: 0.5rem;
      }
    }

    .text {
      font-size: 1.25rem;
      line-height: 2rem;
      color: #333;
    }

    .showItem {
      // flex: 2
    }

    .addressList {
      .item {
        margin: 0.9rem 0;

        .title {
          padding: 0.9rem 0;
        }
      }

      // flex: 2;
    }
  }

  .qrCode {
    align-items: center;
    text-align: center;
    color: #ffffff;
    background: rgb(16, 166, 50);
    opacity: 0.9;
    padding: 2rem 5rem;
    margin-top: 4rem;
    display: flex;
    flex-flow: column;
    font-size: 1.2rem;
    line-height: 2rem;

    a {
      text-decoration: underline;

      &:hover {
        color: #ffffff;
        opacity: 0.8;
      }
    }
  }

  .bannerImg {
    width: 100%;
    display: block;
  }

  .textForm {
    height: 363px;
    background: #ffffff;
    position: relative;

    .formBox {
      position: absolute;
      width: 1234px;
      box-shadow: 0px 0px 30px 0px #0000001a;
      height: 413px;
      top: -135px;
      left: 50%;
      margin-left: -617px;
      z-index: 2;
      background: #ffffff;
      border-radius: 12px;
      padding: 40px 72px;
      box-sizing: border-box;

      .titles {
        color: #254193;
        font-size: 40px;
        font-weight: bold;
        text-align: left;
      }

      .bottom {
        display: flex;
        // align-items: center;
        // justify-content: space-between;
        margin-top: 36px;

        .left {
          width: 50%;
          border-right: 1px solid #ececec;
          padding: 0 50px 0 40px;
          box-sizing: border-box;

          .item {
            width: 100%;
            text-align: left;
            position: relative;

            .tips {
              font-size: 0.8rem;
              line-height: 36px;
              color: #999;
            }

            .t1 {
              font-size: 16px;
              color: #444444;
              margin-bottom: 12px;
            }

            .p {
              font-size: 16px;
              color: #444444;
              line-height: 22.4px;

              span {
                display: inline-block;
                margin-bottom: 8px;
                margin-right: 24px;

                &:nth-child(2n) {
                  margin-right: 0;
                }
              }
            }

            &:first-child {
              margin-bottom: 48px;
            }

            img {
              position: absolute;
              top: 0;
              left: -40px;
            }
          }
        }

        .right {
          width: 50%;
          padding: 0 0 0 60px;
          box-sizing: border-box;
          position: relative;
          .mack {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 2;
          }
          .textarea {
            width: 100%;
            height: 172px;
            border-radius: 4px;
            border: 1px solid #d9d9d9;
            padding: 12px 16px;
            box-sizing: border-box;
            font-size: 16px;
            line-height: 22.4px;
            resize: none;
          }

          .send {
            width: 180px;
            height: 48px;
            border-radius: 4px;
            border: 1px solid #254193;
            background: #254193;
            margin-top: 24px;
            display: flex;
            align-items: center;
            cursor: pointer;
            justify-content: center;

            img {
              width: 28px;
            }
          }
        }
        .H5 {
          display: none;
        }
      }
    }
  }
}
</style>
